import React from "react";
import { Navigate, Outlet, useLocation, useParams } from "react-router";
import ContentWrapper from "../../components/layout/ContentWrapper";
import { LoadingIndicator, useAuth } from "../../components";
import InviteInvalid from "./components/InviteInvalid";
import { InviteRouteParams } from "./models";
import { useGetInvitationValidationQuery } from "./queries";

const InviteOutlet: React.FC = (): React.ReactElement => {
  const { authenticated } = useAuth();

  const params = useParams<InviteRouteParams>();
  const location = useLocation();

  const invitationValidationQuery = useGetInvitationValidationQuery(
    params.invitationGuid,
  );

  if (invitationValidationQuery.isFetching) {
    return (
      <ContentWrapper largePadding>
        <LoadingIndicator />
      </ContentWrapper>
    );
  }

  if (
    authenticated &&
    invitationValidationQuery.isSuccess &&
    !location.pathname.includes("/accept") &&
    !location.pathname.includes("/register") &&
    !location.pathname.includes("/login")
  ) {
    return <Navigate to="accept" replace />;
  }

  if (invitationValidationQuery.isError) {
    return (
      <InviteInvalid onRetry={() => invitationValidationQuery.refetch()} />
    );
  }

  return <Outlet />;
};

export default InviteOutlet;
